import { useState, useEffect } from 'react';
import { Input } from '@bancobarigui/barihaus';

interface MaxLimitFieldProps {
  value: number;
  onChange: (value: number | undefined) => void;
  label: string;
  placeholder?: string;
}

export function MaxLimitField({
  value,
  onChange,
  label,
  placeholder = 'Ilimitado',
}: MaxLimitFieldProps) {
  const [internalValue, setInternalValue] = useState<string>(value === 0 ? '' : String(value || ''));

  useEffect(() => {
    setInternalValue(value === 0 ? '' : String(value || ''));
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setInternalValue(inputValue);

    if (inputValue === '' || inputValue === null || inputValue === undefined) {
      onChange(undefined);
    } else {
      const numValue = Number(inputValue);
      if (!isNaN(numValue) && numValue > 0) {
        onChange(numValue);
      } else if (inputValue === '0') {
        onChange(undefined);
      }
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-600 mb-2">
        {label}
      </label>
      <Input
        type="number"
        size="middle"
        value={internalValue}
        onChange={handleChange}
        placeholder={placeholder}
        min={0}
      />
    </div>
  );
}
